// @flow @jsx h

import { h, Component } from 'preact'

import { TIERS } from '../../constants/'
import { imagePaths } from '../../config/images'

class WhaleImagesLoader extends Component<{}, {}> {
  render() {
    return (
      <div style={{ display: 'none' }}>
        {Object.keys(TIERS).map(tier => (
          <img key={`image-loader-${tier}`} alt='' src={imagePaths[tier]} />
        ))}
      </div>
    )
  }
}

export { WhaleImagesLoader }



// WEBPACK FOOTER //
// ./src/v1/components/Background/WhaleImagesLoader.js